import { ResortIdEnum } from '@alluradirect/react';
import { Box } from '@mui/material';
import { LoadingIndicator } from 'components/core/LoadingIndicator/LoadingIndicator';
import { FormikAppRadioGroup } from 'components/formik/core/FormikAppRadioGroup/FormikAppRadioGroup';
import { FormikAppSelect } from 'components/formik/core/FormikAppSelect/FormikAppSelect';
import { useFormikContext } from 'formik';
import Grid from 'components/core/Grid';
import { useResortsQuery } from 'hooks/api/location/useResortsQuery';

export const ListPageResortFormInputs = () => {
  const resortsQuery = useResortsQuery();
  const { values, setFieldValue } = useFormikContext<any>();
  const isOtherSelected = values.isOtherResortSelected === true;

  if (!resortsQuery.data) return <LoadingIndicator height={'20vh'} />;

  const resorts = resortsQuery.data.DATA.RESORTS;

  const resortButtons = resorts
    .filter(
      (resort: any) =>
        resort.ID === ResortIdEnum.Whistler ||
        resort.ID === ResortIdEnum.BigWhite ||
        resort.ID === ResortIdEnum.SunPeaks,
    )
    .map((item: any) => ({
      title: item.NAME,
      value: item.ID,
      onClick: () => {
        setFieldValue('isOtherResortSelected', false);
      },
    }));

  const resortSelectOptions = resorts
    .filter(
      (resort: any) =>
        resort.ID != ResortIdEnum.Whistler && resort.ID != ResortIdEnum.BigWhite && resort.ID != ResortIdEnum.SunPeaks,
    )
    .map((item: any) => ({
      label: item.NAME,
      value: item.ID,
    }));

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormikAppRadioGroup name="resortId" buttons={[...resortButtons]} isRow titleStyle={{ fontSize: 16 }} />
      </Grid>
      <Grid item xs={12}>
        <FormikAppRadioGroup
          name="isOtherResortSelected"
          isRow
          titleStyle={{ fontSize: 16 }}
          buttons={[
            {
              title: 'Other',
              value: true,
              onClick: () => {
                setFieldValue('resortId', resortSelectOptions[0].value);
              },
            },
          ]}
        />
      </Grid>
      {isOtherSelected ? (
        <Grid item xs={12}>
          <Box>
            <FormikAppSelect name="resortId" options={resortSelectOptions} size="medium" />
          </Box>
        </Grid>
      ) : null}
    </Grid>
  );
};
